import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Card, App } from "antd";
import { updateEventId } from "api/events";
import { useI18n } from "components/I18nProvider";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DangerZone from "./DangerZone";
import { fetchConfig } from "api/config";
import { buildUrlPath } from "lib/resolveUrl";
import EventCodeForm from "components/EventCodeForm";
import styles from './style.module.scss';
/** Set `true` to show event URL editing on Settings again (currently done when creating an event). */
const SHOW_EVENT_URL_IN_SETTINGS = false;
const EventUrlEditorSection = ({ eventId }) => {
    const { intl } = useI18n();
    const navigate = useNavigate();
    const { message } = App.useApp();
    const [urlField, setUrlField] = useState("ready");
    const [eventOrigin, setEventOrigin] = useState(intl.formatMessage({ id: 'loading' }));
    useEffect(() => {
        const fetchConfigState = async () => {
            const config = await fetchConfig();
            setEventOrigin(config.publicEventOrigin);
        };
        void fetchConfigState();
    }, []);
    const handleSubmit = async (code) => {
        setUrlField("saving");
        const result = await updateEventId(eventId, code);
        if (result === 'already-exists') {
            void message.error(intl.formatMessage({ id: 'eventIdExists' }));
        }
        else {
            navigate(buildUrlPath(`/admin/events/${code}/settings`), { replace: true });
        }
        setUrlField("ready");
    };
    const inputLead = _jsxs("span", { className: styles.urlBase, children: [eventOrigin, "#"] });
    return (_jsx(EventCodeForm, { initialCode: eventId, buttonLoading: urlField === "saving", inputLead: inputLead, submitLabel: intl.formatMessage({ id: 'set' }), onSubmit: handleSubmit }));
};
const SettingsSubpage = () => {
    const { intl } = useI18n();
    const { eventId } = useParams();
    if (eventId === undefined) {
        return _jsx("p", { children: intl.formatMessage({ id: 'loading' }) });
    }
    return (_jsxs(Card, { title: intl.formatMessage({ id: 'settings' }), children: [SHOW_EVENT_URL_IN_SETTINGS ? (_jsx(EventUrlEditorSection, { eventId: eventId })) : null, _jsx(DangerZone, { eventId: eventId })] }));
};
export default SettingsSubpage;
